import { string, arrayOf, object } from "prop-types";
import React from "react";

import { Trans, useTranslation } from "@lib/i18n";

const QuestionList = ({ questions, title, section }) => {
  const { t } = useTranslation();

  return (
    <ul className="my-4" data-id={`question-${title}-content`}>
      {questions.map(({ links }, questionIndex) => {
        const baseKey = `footer.faq.sections.${section}.questions.${questionIndex}`;
        const question = `${baseKey}.question`;
        const answer = `${baseKey}.answer`;

        if (!t(question) && !t(answer)) {
          return null;
        }

        return (
          <li key={questionIndex}>
            <h5 className="text-base font-semibold">
              <Trans i18nKey={question} />
            </h5>
            <p className="m-0 pb-4">
              <Trans i18nKey={answer}>
                {Array.isArray(links) &&
                  links.filter(Boolean).map((_, linkIndex) => {
                    const link = t(`${baseKey}.links.${linkIndex}`);

                    if (!link) {
                      return;
                    }

                    return (
                      <a
                        className="text-primaryOrange underline"
                        href={link}
                        key={linkIndex}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ link }}
                      </a>
                    );
                  })}
              </Trans>
            </p>
          </li>
        );
      })}
    </ul>
  );
};

QuestionList.propTypes = {
  questions: arrayOf(object),
  title: string,
  section: string,
};

export default QuestionList;
